// extracted by mini-css-extract-plugin
module.exports = {"primaryTrailLink":"styles_primaryTrailLink__6_X_q","thumbnail":"styles_thumbnail__98srZ","text":"styles_text__ogBG4"};